export const getGermanyData = () => ({
  name: "Allemagne",
  description: "L'Allemagne est un pays viticole traditionnel réputé pour ses vins blancs élégants, notamment le Riesling. Le pays produit des vins de qualité dans 13 régions viticoles, avec une diversité de styles allant des vins secs aux vins liquoreux prestigieux.",
  type: "country",
  regions: [
    { name: "Rheinhessen", area: "26,000 ha", percentage: "25%", description: "Plus grande région" },
    { name: "Pfalz", area: "23,000 ha", percentage: "22%", description: "Riesling emblématique" },
    { name: "Baden", area: "16,000 ha", percentage: "15%", description: "Vins rouges" },
    { name: "Mosel", area: "9,000 ha", percentage: "9%", description: "Vins minéraux" },
    { name: "Württemberg", area: "11,000 ha", percentage: "11%", description: "Vins rouges" },
    { name: "Autres", area: "19,000 ha", percentage: "18%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Rheinhessen", x: 8.0, y: 49.8, color: "#4B164C", size: 7 },
    { region: "Pfalz", x: 8.0, y: 49.2, color: "#6d2c7a", size: 6 },
    { region: "Baden", x: 8.5, y: 48.5, color: "#8a4a8a", size: 5 },
    { region: "Mosel", x: 7.0, y: 49.8, color: "#a768a6", size: 4 },
    { region: "Württemberg", x: 9.5, y: 48.8, color: "#c486c4", size: 4 }
  ],
  statistics: {
    totalArea: "104,000 ha",
    production: "9 million hectolitres",
    regions: "13 régions principales",
    appellations: "40+ appellations",
    exportPercentage: "20%"
  },
  characteristics: {
    climate: "Climat continental avec influences atlantiques, étés chauds et hivers froids",
    soil: "Sols calcaires, argileux, schisteux, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Vins rouges élégants et structurés, principalement Spätburgunder (Pinot Noir)",
    white: "Vins blancs secs et aromatiques, Riesling emblématique",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sweet: "Vins liquoreux exceptionnels, notamment les Eiswein et Trockenbeerenauslese"
  },
  history: "La viticulture allemande remonte à l'époque romaine. Les moines ont développé les techniques viticoles au Moyen Âge. L'Allemagne a une tradition viticole millénaire, avec des cépages autochtones comme le Riesling. Aujourd'hui, l'Allemagne est reconnue pour ses vins blancs de qualité et ses vins liquoreux prestigieux.",
  foodPairing: "Cuisine allemande traditionnelle : saucisses, choucroute, schnitzel, fromages affinés. Les vins allemands s'accordent parfaitement avec la cuisine locale et les plats internationaux."
}); 